module.exports = __webpack_public_path__ + "img/80102101.5c01ac5f.png";